<template>
  <div class="content">
    <!--  -->
    <el-row style="height: 3vh; padding-left: 0.5vw; padding-top: 0.1vh">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>合同信息</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height: calc(100% - 3vh); width: 100%; position: relative">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height: 100%" class="aside">
        <el-card style="height: 100%; overflow-y: auto">
          <el-tree :data="dataTree" ref="tree" :props="defaultProps" default-expand-all :expand-on-click-node="false"
            :highlight-current="true" @node-click="handleNodeClick" node-key="id" :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys">
          </el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main class="build-CURD" style="
          height: 100%;
          padding: 0px !important;
          padding-left: 20px !important;
          position: relative;
          width: 84%;
        ">
        <el-card class="box-card box-card_right" style="height: 100%; padding: 0px !important">
          <!-- 搜索框上 -->
          <div style="
              margin: 10px 20px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 60px;
            ">
            <div class="grid-search">
              <el-input v-model="search.name" placeholder="请输入姓名" clearable @input="watchInput">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div>
            <div style="
                display: flex;
                align-items: center;
                width: 25%;
                justify-content: space-between;
              ">
              <el-date-picker v-model="search.month" @change="doFilter" type="month" value-format="yyyy-MM"
                placeholder="选择月"></el-date-picker>
              <div style="display: flex; margin: 0px 0px 0px 10px">
                <el-tooltip class="item" effect="dark" content="导出表" placement="top-end"
                  v-if="isMenuExit('pro:contract:export')">
                  <img @click="exportAgree" class="icon_hover" src="../../assets/image/export.png" alt="" srcset="" />
                </el-tooltip>
                <el-upload class="upload-demo" :action="uploadPersonUrl" :headers="uploadHead" :data="uploadPersonData"
                  :show-file-list="false" style="margin-left: 50px" :on-success="personSuccess"
                  v-if="isMenuExit('pro:contract:port')">
                  <el-tooltip class="item" effect="dark" content="导入表" placement="top-end">
                    <img class="icon_hover" src="../../assets/image/import.png" alt="" srcset="" />
                  </el-tooltip>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="build-table">
            <el-table :data="listData" height="100%" style="width: 100%" ref="tableLay"
              :header-cell-style="{ background: '#F5F7F9', color: '#909399' }">
              <template slot="empty">
                <p>{{ dataText }}</p>
              </template>
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  <a>{{ scope.row.index }}</a>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <a>{{ scope.row.name }}</a>
                </template>
              </el-table-column>
              <el-table-column label="身份证号">
                <template slot-scope="scope">
                  <span>{{ scope.row.idCard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="开户行" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.bank }}</span>
                </template>
              </el-table-column>
              <el-table-column label="银行卡号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.bankCard }}</span>
                </template>
              </el-table-column>
              <el-table-column label="行号" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.lineNumber }}</span>
                </template>
              </el-table-column>

              <el-table-column label="劳动合同" v-if="showProjectId !== '1289074018111930369'">
                <template slot-scope="scope">
                  <div @click="exportAgreeCon(scope.row)">
                    <img style="width: 32px; height: 32px; cursor: pointer" src="../../assets/image/agree.png" />
                  </div>
                </template>
              </el-table-column>

              <el-table-column label="合同工资（元）" sortable prop="cashContract">
                <template slot-scope="scope">
                  <span>{{ scope.row.cashContract }}</span>
                </template>
              </el-table-column>
              <el-table-column label="合同开始时间" sortable prop="contractStartTime" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractStartTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="合同结束时间" sortable prop="contractEndTime" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.contractEndTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="合同附件">
                <template slot-scope="scope">
                  <div style="width: 100%; display: flex; justify-content: center" v-if="scope.row.imageUrl == ''">暂无数据
                  </div>
                  <div v-else style="width: 100%; display: flex; justify-content: center" width="300">
                    <el-image v-if="isImg(scope.row.imagePath)" style="width: 5vh; height: 5vh"
                      :src="scope.row.imageUrl" :preview-src-list="[scope.row.imageUrl]"></el-image>
                    <el-button v-else type="text" @click="showContract(scope.row)">查看合同</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="是否网签" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <span v-if="scope.row.bankCard && scope.row.cashContract">是</span>
                  <span v-else>否</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.row)" type="warning">修改</el-button>
                </template>
              </el-table-column>
            </el-table>

            <!-- 导入弹出框 -->
            <el-dialog :title="dialogTitle1" :visible.sync="imoportVisible" center :append-to-body="true"
              :before-close="handleClose1" :lock-scroll="false" width="30%">
              <template>
                <el-table :data="tableData1" style="width: 100%" border>
                  <el-table-column label="状态" width="100">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status == 0">
                        <i class="el-icon-circle-check" style="color: #07c160"></i>
                      </span>
                      <span v-if="scope.row.status == 1">
                        <i class="el-icon-warning-outline" style="color: #f00"></i>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reason" label="原因">
                    <template slot-scope="scope">
                      <span v-if="scope.row.status == 0" style="color: #07c160">{{ scope.row.result }}</span>
                      <span v-if="scope.row.status == 1" style="color: #f00">{{
        scope.row.result
      }}</span>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-dialog>
          </div>
          <!-- 分页 -->
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalItems"></el-pagination>
        </el-card>
      </el-main>
    </el-container>
    <!-- 修改弹出框 -->
    <el-dialog title="合同信息编辑" :visible.sync="imgVis" center :append-to-body="true" :lock-scroll="false" width="40%">
      <el-form :model="imgForm" ref="imgForm" label-width="140px" :label-position="labelPosition">
        <el-form-item label="合同开始时间：">
          <el-date-picker v-model="imgForm.contractStartTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间：">
          <el-date-picker v-model="imgForm.contractEndTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开户行：">
          <el-input v-model="imgForm.bank"></el-input>
        </el-form-item>
        <el-form-item label="银行卡号：">
          <el-input v-model="imgForm.bankCard"></el-input>
        </el-form-item>
        <el-form-item label="行号：">
          <el-input v-model="imgForm.lineNumber"></el-input>
        </el-form-item>
        <el-form-item label="合同金额：">
          <el-input v-model="imgForm.cashContract"></el-input>
        </el-form-item>
        <el-form-item label="合同附件：">
          <div style="width:100%;height:100%;postion:relative;display: flex;flex-wrap: wrap;">
            <div v-for="item in imgForm.photoList" :key="item.uid"
              style="width:10vh;height:10vh;postion:relative;padding:0.5vh;">
              <el-image v-if="item.srcList.length > 0" style="width: 100%; height: 100%" :src="item.icon"
                :preview-src-list="item.srcList"></el-image>
              <el-image v-else style="width: 100%; height: 100%;padding:10px;cursor: pointer;"
                @click="downLoadFun(item)" :src="item.icon"></el-image>
              <i class="el-icon-error" @click="delImg(item)"
                style="position:absolute;top:1vh;right:1vh;width: 3vh;height: 3vh;cursor: pointer;color: red;font-size: 3vh;"></i>
            </div>
            <el-upload class="avatar-uploader" :action="uploadUrl" :headers="uploadHead" :data="uploadData"
              :show-file-list="false" :on-success="handleAppSuccess" style="margin-left:1vw;">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="imgVis = false">取 消</el-button>
        <el-button type="primary" @click="saveImg">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 查看信息 -->
    <el-dialog title="合同附件" :visible.sync="imgInfoVis" center :append-to-body="true" :lock-scroll="false" width="40%">
      <el-form :model="imgInfo" ref="imgInfo" label-width="100px" :label-position="labelPosition">
        <el-form-item label="合同附件：">
          <div style="width:100%;height:100%;postion:relative;display: flex;flex-wrap: wrap;">
            <div v-for="(item, index) in imgInfo.photoList" :key="index"
              style="width:10vh;height:10vh;postion:relative;padding:0.5vh;">
              <el-image v-if="item.srcList.length > 0" style="width: 100%; height: 100%" :src="item.icon"
                :preview-src-list="item.srcList"></el-image>
              <el-image v-else style="width: 100%; height: 100%;padding:10px;cursor: pointer;"
                @click="downLoadFun(item)" :src="item.icon"></el-image>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      showProjectId: util.session.get('groupId'),
      dataTree: [],
      listData: [],
      search: {
        //查询
        name: '',
        projectId: '',
        month: '',
      },
      classId: '', //班组id
      projectEntId: '',//参建单位
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      dataText: '数据加载中...',
      uploadPersonUrl: myHttp.importTeamsPersonContractList,
      uploadPersonData: {
        projectId: '',
      },
      uploadUrl: base.url + '/upload/uploadPhoto', //图片上传地址
      uploadHead: {
        accessToken: this.$store.state.token,
      },
      uploadData: {
        type: 205,
      },
      typeName: '工种',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      dialogTitle1: '导入结果',
      imoportVisible: false,
      tableData1: [],
      curKey: '',
      groupId: '',
      //修改弹出框
      labelPosition: 'right',
      imgForm: {
        id: '',
        contractStartTime: '',
        contractEndTime: '',
        bank: '',
        bankCard: '',
        lineNumber: '',
        imagePath: '',
        photoList: [],
        idCard: '',
        projectId: '',
        cashContract: 0
      },
      imgVis: false,
      //图片信息弹出框
      imgInfoVis: false,
      imgInfo: {
        photoList: []
      },
    }
  },
  created() {
    this.search.projectId = this.$store.state.groupId
    if (base.ids.indexOf(util.session.get('groupId')) != -1) {
      this.$router.push('/contractWorker01')
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.uploadPersonData.projectId = this.groupId
    this.teamTree() //获取组织树
  },
  methods: {
    // 搜索数据
    doFilter(index) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      myHttp.getTeamsPersonContractList({
        projectId: this.groupId,
        teamsId: this.classId,
        time: this.search.month,
        projectEntId: this.projectEntId,
        name: this.search.name,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.entity.list || []
          for (var i = 0; i < list.length; i++) {
            list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            list[i].imageUrl = list[i].imagePath && list[i].imagePath != '' ? base.httpCtx + list[i].imagePath.split(',')[0] : ''
          }
          that.listData = list
          console.log(that.$refs)
          that.$refs.tableLay.doLayout()
          if (that.listData.length == 0) {
            that.dataText = '暂无数据'
          }
          that.totalItems = resp.data.data.entity.total || 0
        } else {
          that.$message.error(resp.data.msg)
          that.dataText = '暂无数据'
        }
      }, function () {
        that.dataText = '服务器繁忙中，请稍后请求'
      })
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },

    //点击树形结构
    handleNodeClick(data) {
      if (data.type == '0') {
        this.classId = data.id
        this.projectEntId = ''
        this.getData()
      } else if (data.type == '1') {
        this.classId = ''
        this.projectEntId = data.id
        this.getData()
      } else {
        this.classId = ''
        this.projectEntId = ''
        this.getData()
      }
    },
    //获取树形结构
    teamTree() {
      var that = this
      myHttp.getEntTeams({
        projectId: this.search.projectId,
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var list = resp.data.data.list || []
          for (var i = 0; i < list.length; i++) {
            if (list[i].type == '0' && that.curKey == '') {
              that.curKey = list[i].id
              that.classId = list[i].id
              that.search.teamsId = list[i].id
            }
          }
          var tree = util.common.listToTree('id', 'parentId', list)
          var obj = [{ name: '全部', id: '0', parentId: '', children: [] }]
          obj[0].children = tree
          that.dataTree = obj
          that.getData()
          setTimeout(function () {
            that.$refs.tree.setCurrentKey(that.curKey)
          }, 100)
        }
      })
    },
    watchInput(e) {
      // console.log(e)
      this.search.personStatus = e
      this.getData()
    },
    /**
     * 导出合同
     */
    exportAgree() {
      // if (!this.classId || this.classId == '') {
      //   this.$message.error('请先选择班组！')
      //   return
      // }
      var token = util.session.get('token')
      window.open(
        myHttp.exportTeamsPersonContractList +
        '?teamsId=' +
        this.classId +
        '&projectEntId=' +
        this.projectEntId +
        '&name=' +
        this.search.name +
        '&time=' +
        this.search.month +
        '&projectId=' +
        this.search.projectId +
        '&accessToken=' +
        token
      )
    },
    /**
     * 导出合同
     */
    exportAgreeCon(row) {
      var token = util.session.get('token')
      window.open(
        myHttp.exportContract +
        '?teamsId=' +
        row.teamsId +
        '&personId=' +
        row.personId +
        '&projectId=' +
        this.search.projectId +
        '&accessToken=' +
        token
      )
    },
    /**
     * 导入表监听方法
     */
    personSuccess(res, file) {
      if (res.code == '200') {
        this.$message.success('上传成功')
        // console.log(res)
        this.imoportVisible = true
        this.tableData1 = res.data.resultMap
        this.getData()
      } else {
        this.$message.error(res.msg)
      }
    },
    //上传合同成功监听方法
    // handleAppSuccess(res, file, opt, id) {
    //   console.log(res, file, opt, id)
    //   if (res.code == '200') {
    //     var path = res.data.saveUrls
    //     this.saveImg(id, path)
    //   } else {
    //     this.$message.error(res.msg)
    //   }
    // },

    //保存合同图片信息
    // saveImg(id, path) {
    //   var that = this
    //   myHttp
    //     .saveContractImg({
    //       id: id,
    //       path: path,
    //     })
    //     .then(function (resp) {
    //       console.log(resp)
    //       if (resp.data.code == '200') {
    //         that.$message.success('上传成功')
    //         that.getData()
    //       } else {
    //         that.$message.error(resp.msg)
    //       }
    //     })
    // },
    //打开上传弹出框
    handleEdit(row) {
      this.imgForm.id = row.contractId
      this.imgVis = true
      this.imgForm.contractStartTime = row.contractStartTime
      this.imgForm.contractEndTime = row.contractEndTime
      this.imgForm.idCard = row.idCard
      this.imgForm.bank = row.bank
      this.imgForm.bankCard = row.bankCard
      this.imgForm.lineNumber = row.lineNumber
      this.imgForm.cashContract = row.cashContract
      this.imgForm.imagePath = row.imagePath || ''
      this.imgForm.projectId = row.projectId
      var objs = row.imagePath ? row.imagePath.split(',') : []
      this.imgForm.photoList = []
      for (var i = 0; i < objs.length; i++) {
        var icon = this.getIcon(objs[i])
        var isImg = base.imgType.indexOf(objs[i].split('.')[1]) > -1 ? true : false
        var obj = {
          uid: i + '',
          icon: icon,
          url: objs[i].startsWith('http') ? objs[i] : base.httpCtx + objs[i],
          baseUrl: objs[i],
          srcList: isImg ? [base.httpCtx + objs[i]] : []
        }
        this.imgForm.photoList.push(obj)
      }
    },
    //上传合同成功监听方法
    handleAppSuccess(res, file) {
      if (res.code == '200') {
        var path = res.data.saveUrls
        var icon = this.getIcon(path)
        var isImg = base.imgType.indexOf(path.split('.')[1]) > -1 ? true : false
        var obj = {
          uid: file.uid,
          icon: icon,
          url: base.httpCtx + path,
          baseUrl: path,
          srcList: isImg ? [base.httpCtx + path] : []
        }
        this.imgForm.photoList.push(obj)
      } else {
        this.$message.error(res.msg)
      }
    },
    getIcon(url) {
      var li = url.split('.')[1]
      var result = ''
      if (base.imgType.indexOf(li) > -1) {
        result = base.httpCtx + url
      } else if (base.pdfType.indexOf(li) > -1) {
        result = require('../../assets/image/office/pdf.png')
      } else if (base.zipType.indexOf(li) > -1) {
        result = require('../../assets/image/office/zip.png')
      } else {
        result = require('../../assets/image/office/undefined.png')
      }
      return result
    },
    //删除
    delImg(row) {
      var list = this.imgForm.photoList
      var list1 = []
      for (var i = 0; i < list.length; i++) {
        if (row.uid == list[i].uid) {

        } else {
          list1.push(JSON.parse(JSON.stringify(list[i])))
        }
      }
      this.imgForm.photoList = list1
    },

    //保存合同图片信息
    saveImg() {
      var that = this
      var path = ''
      for (var i = 0; i < this.imgForm.photoList.length; i++) {
        if (path == '') {
          path = this.imgForm.photoList[i].baseUrl
        } else {
          path += ',' + this.imgForm.photoList[i].baseUrl
        }
      }
      this.imgForm.imagePath = path
      myHttp.updateContract(this.imgForm).then(function (resp) {
        if (resp.data.code == '200') {
          that.imgVis = false
          that.$message.success('修改成功')
          that.getData()
        } else {
          that.$message.error(resp.data.msg)
        }
      })
    },
    handleClose1() {
      this.imoportVisible = false
    },
    //下载文件
    downLoadFun(row) {
      window.open(row.url)
    },

    /**
     * 判断是否展示
     */
    isMenuExit(row) {
      var flag = util.common.filterBtnMenu(row)
      return flag
    },

    /**
     * 展示合同
     */
    showContract(row) {
      // var that = this
      // window.open(
      //   base.httpCtx + row.imagePath
      // )
      this.imgInfoVis = true
      this.imgInfo.photoList = []
      var imagePath = row.imagePath || ''
      var objs = imagePath && imagePath != '' ? imagePath.split(',') : []
      for (var i = 0; i < objs.length; i++) {
        var icon = this.getIcon(objs[i])
        var isImg = base.imgType.indexOf(objs[i].split('.')[1]) > -1 ? true : false
        var obj = {
          uid: i + '',
          icon: icon,
          url: objs[i].startsWith('http') ? objs[i] : base.httpCtx + objs[i],
          baseUrl: objs[i],
          srcList: isImg ? [base.httpCtx + objs[i]] : []
        }
        this.imgInfo.photoList.push(obj)
      }
    },
    // 上传前判断格式
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(testmsg)
      const extension = testmsg === "jpg" || testmsg === "png"
      if (!extension) {
        this.$message({
          message: "上传文件只能是.jpg或者.png格式!",
          type: "warning",
        });
      }
      return extension;
    },
    //判断是否是图片
    isImg(url) {
      var str = url.split('.')[1]
      if (base.imgType.indexOf(str) > -1) {
        return true
      } else {
        return false
      }
    },

  },
}
</script>
<style>
/**
  *图片放大右上角关闭按钮
  */
.el-image-viewer__close i {
  font-size: 4vh;
  color: #fff;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
</style>
<style scoped>
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}

.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}

/* .grid-search {
    display: flex;
    justify-content: space-between;
    margin: 0px 20px 0;
    height: 66px;
  } */
.content>>>.el-card__body {
  padding: 0 !important;
  height: 100% !important;
}

.build-table {
  height: calc(100% - 130px);
}

.active {
  background: #409eff;
  color: #fff;
}

.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}

.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}

.content>>>.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4d95fd;
  font-weight: bold;
}

.content>>>.el-input-group--append .el-input__inner {
  width: 200px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 9vh;
  height: 9vh;
  line-height: 9vh;
  text-align: center;
}

.avatar {
  width: 9vh;
  height: 9vh;
  display: block;
}
</style>